export default "__VITE_ASSET__BAyw1Kb2__"